import { defineCustomElement } from "vue";
import VCBannerEduca from "./F360BannerEduca.ce.vue";
import { Register } from "@/ui/vue-components/components";

const path = { tag: "vc-banner-educa", component: VCBannerEduca };

const _register: Register = {
  register() {
    if (!customElements.get(path.tag)) {
      const CustomElement = defineCustomElement(path.component);
      customElements.define(path.tag, CustomElement);
    }
  }
};

export default _register;
